import React, { useState } from 'react';
import ShareWishlistButton from './ShareWishlistButton';
import SharedWishlistLink from './SharedWishlistLink';

const ShareWishlistContainer = (activeList) => {
    const [showInfo, setShowInfo] = useState(false);

    const onToggle = () => {
        setShowInfo(!showInfo);
    };

    return (
        <>
            {showInfo == true && (
                <SharedWishlistLink
                    onClose={() => onToggle()}
                    activeList={activeList}
                />
            )}
            <ShareWishlistButton onClick={() => onToggle()} />
        </>
    );
};

export default ShareWishlistContainer;